import Vue from 'vue'
// 用于导入步骤模块多个组件之间共享数据，
// 替换原来的top变量

const importVue = new Vue({
	data() {
		return {
			name: '',
			currentSelectId: '',
			// 临时存放当前所使用的配置
			pubdataImportconfig: {},
			tmpPublicImportData: [],
			tmpDataImportData: '',
			modelUrl: ''
		}
	}
})

export default importVue
